// extracted by mini-css-extract-plugin
export default {"button":"expand-button-module__button__Q8fpa0P","expanded":"expand-button-module__expanded__fgQ8LKQ"};